import { useRef, useState } from "react";
import { formatBytes } from "../../../utils/function";
import FolderIcon from "../../Icon-SVG/FolderIcon";
import "./styles.scss";

const FileUpload = ({
  file,
  setFile,
  setFileError,
  allowedExtensions = [],
  errorMessage = "",
  digitsShowed = 2,
  maxSize = 0,
  styles,
  mid = "file-upload", // Default ID
}) => {
  const fileInputRef = useRef(null);

  const [dragActive, setDragActive] = useState(false);

  const isExtensionAllowed = (selectedFile) => {
    if (allowedExtensions.length === 0) {
      return true;
    }
    const extension = selectedFile.name.split(".").pop().toLowerCase();
    if (!allowedExtensions.map((ext) => ext.toLowerCase()).includes(extension)) {
      setFileError(errorMessage);
      setFile(null);
      return false;
    }
    return true;
  };

  const fileChangeHandler = (e) => {
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];
      if (!isExtensionAllowed(selectedFile)) return;
      if (maxSize && selectedFile.size > maxSize) {
        setFileError("File is too big");
        setFile(null);
        return;
      }
      setFileError("");
      setFile(selectedFile);
    }
  };

  const removeHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setFile(null);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const dragEnterHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const dragExitHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
  };

  const dropHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const selectedFile = e.dataTransfer.files[0];
      if (!isExtensionAllowed(selectedFile)) return;
      setFileError("");
      setFile(selectedFile);
    }
  };

  return (
    <form
      className="file-upload"
      onSubmit={(e) => e.preventDefault()}
      onDragEnter={dragEnterHandler}
      style={{ width: styles?.formWidth, height: styles?.formHeight }}>
      <input
        id={mid} // Use the unique ID here
        ref={fileInputRef}
        className="file-upload__input"
        type="file"
        onChange={fileChangeHandler}
      />
      <label
        htmlFor={mid} // Use the same unique ID here
        className={`file-upload__label ${dragActive ? "file-upload__label--active" : ""}`}>
        {file ? (
          <div className="file-upload__uploaded-file" style={{ fontSize: styles?.fontSize }}>
            <span>{file.name}</span>
            <span>{formatBytes(file.size, digitsShowed)}</span>
            <span className="file-upload__uploaded-file__remove" onClick={removeHandler}>
              x
            </span>
          </div>
        ) : (
          <>
            <div
              className="file-upload__icon"
              style={{ width: styles?.iconContainerWidth, height: styles?.iconContainerHeight }}>
              <FolderIcon width={styles?.iconWidth} height={styles?.iconHeight} />
            </div>
            <p
              className="file-upload__info-text"
              style={{
                fontSize: styles?.fontSize,
                padding: styles?.infoTextPadding,
                width: styles?.infoTextWidth,
              }}>
              Drag & Drop your file here or <b style={{ color: "var(--color-blue)" }}>browse</b> to
              upload
            </p>
          </>
        )}
      </label>
      {dragActive && (
        <div
          className="file-upload__drag-file-element"
          onDragEnter={dragEnterHandler}
          onDragLeave={dragExitHandler}
          onDragOver={dragEnterHandler}
          onDrop={dropHandler}></div>
      )}
    </form>
  );
};

export default FileUpload;
